import NegotiationTab from "../../../../patient/details/negotiation/NegotiationTab";

export default function NegotiationDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <NegotiationTab inWorkQ={inWorkQ} />
    </div>
}
